<template>
  <b-form-group
    :label="$t('fields.priority')"
    label-for="priority"
  >
    <b-form-radio-group
      id="priority"
      v-model="dataItem.id_task_priorities"
      :options="priorityOptions"
      buttons
      class="w-100"
      button-variant="outline-primary"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup, BFormRadioGroup } from 'bootstrap-vue'
import { PRIORITY_SLUGS } from '@/libs/priorities'

export default {
  name: 'TasksPriorityCard',
  components: { BFormGroup, BFormRadioGroup },
  computed: {
    priorityOptions() {
      return Object.entries(PRIORITY_SLUGS).map(([value, slug]) => ({ value: Number(value), text: this.$t(`priorities.${slug}`) }))
    },
    dataItem() {
      return this.$store.getters['tasks/dataItem']
    },
  },
}
</script>

<style lang="scss" scoped>
// Dar ekranda dört öncelik düğmesi (EN metinleri daha uzun) satıra sığsın.
@media (max-width: 575.98px) {
  #priority ::v-deep .btn {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
}
</style>
